import { MENU_ITEMS, BRAND } from "../lib/gomill-data";
import { MessageCircle } from "lucide-react";

export default function FoodCard({ item }) {
  const message = encodeURIComponent(`Hi GoMill, I'd like to enquire about: ${item.name}`);
  const waLink = `https://wa.me/${BRAND.whatsapp}?text=${message}`;

  return (
    <article
      data-testid={`food-card-${item.id}`}
      className="bg-white rounded-3xl overflow-hidden border border-gomill-border hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col group"
    >
      <div className="relative h-48 md:h-56 bg-gomill-cream overflow-hidden">
        <img
          src={item.image}
          alt={item.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-3 left-3 flex flex-wrap gap-2">
          {item.badges?.map((b) => (
            <span key={b} className="bg-white/95 backdrop-blur text-gomill-green text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider shadow-sm">{b}</span>
          ))}
        </div>
      </div>
      <div className="p-5 flex flex-col gap-2 flex-grow">
        <h3 className="font-serif text-xl text-gomill-green leading-tight">{item.name}</h3>
        <p className="text-sm text-gomill-muted line-clamp-3 flex-grow">{item.desc}</p>
        <a
          href={waLink}
          target="_blank"
          rel="noreferrer"
          data-testid={`food-enquire-${item.id}`}
          className="mt-3 inline-flex items-center justify-center gap-1.5 bg-gomill-cream hover:bg-gomill-mustard text-gomill-green text-sm font-semibold px-4 py-2.5 rounded-full transition-colors"
        >
          <MessageCircle className="w-4 h-4" /> Enquire now
        </a>
      </div>
    </article>
  );
}

export { MENU_ITEMS };
